import { useState } from 'react';
import './ImageWithButtons.css';
import { ImagePreview } from '../../../../components/ImagePreview/ImagePreview';

const defaultButtons = [{ icon: 'icon-eye' }, { icon: 'icon-delete-new', type: 'danger', callback: () =>  {}}];
export const ImageWithButtons = ({ buttons, caption, onDelete,...props }) => {
    const [hidden, setHidden] = useState(true);
    const [prevw, setPrevw] = useState(false);

    return (
        <div className="image-withbuttons-component" onClick={()=>setHidden(prev => !prev)}>
            <img {...props} />
            <div className='buttons-overlay'>
                 <div className={`buttons ${hidden ? 'hidden' : ''}`}>
                    <button onClick={ ()=>setPrevw(true)} className='icon filled small-size'>
                        <i className='icon-eye'></i>
                    </button>
                    <button onClick={onDelete} className='icon filled small-size danger'>
                        <i className='icon-delete-new'></i>
                    </button>
                    
                </div>
                {Boolean(caption) && <span className='caption'>{caption}</span>}

            </div>
            <ImagePreview open={prevw} onClose={()=>setPrevw(false)} src={props.src}/>


        </div>
    )

}